export const path = {
  comments: {
    route: "/comments",
    link: () => path.comments.route,
  },
};
